import flow from 'lodash/flow';
import get from 'lodash/get';
import classnames from 'clsx';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Checkmark from '../../../components/shared/svgIcons/Checkmark';
import { changePlaybackRateIfPossible } from '../../../actions/tuner';
import cssVariables from '../../../styles/variables';
import css from './playback-rate-option.module.scss';

export function PlayBackRateOption({
  value,
  selectedRate,
  className,
  actions,
}) {
  return (
    <div
      className={classnames(css.value, className)}
      onClick={() => actions.changePlaybackRateIfPossible(value)}
    >
      {`${value}x`}
      {value === selectedRate && (
        <Checkmark
          width="16px"
          height="16px"
          viewBox="-5 0 20 10"
          fill={cssVariables['--secondary-color-5']}
          className={css.itemCheckMark}
        />
      )}
    </div>
  );
}

PlayBackRateOption.propTypes = {
  value: PropTypes.number,
  selectedRate: PropTypes.number,
  className: PropTypes.string,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  selectedRate: get(state, 'player.playbackRate', 1.0),
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        changePlaybackRateIfPossible,
      },
      dispatch,
    ),
  };
}

export default flow(connect(mapStateToProps, mapDispatchToProps))(
  PlayBackRateOption,
);
